import { useCallback, useRef } from 'react';

export default function useEventAwaiting(): [() => Promise<void>, () => void] {
  const resolverRef = useRef<() => void>();

  const waitForEvent = useCallback(() => {
    return new Promise<void>(resolve => {
      resolverRef.current = resolve;
    });
  }, []);

  const resolveEvent = useCallback(() => {
    resolverRef.current?.();
    resolverRef.current = undefined;
  }, []);

  return [waitForEvent, resolveEvent];
}
